import Vue from 'vue'
import Vuex from 'vuex'
import * as Toastr from "toastr";
import modules from "./modules";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        toaster: {
            "closeButton": true,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-top-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        },
        user: {},
        userEdit: {},
        group: {},
        website: {},
        theme: {},
        fieldType: {},
        component: {},
        page: {}
    },
    mutations: {
        setUser(state, user) {
            localStorage.setItem('user', JSON.stringify(user));
            state.user = user
        },
        setGroupToEdit: (state, group) => state.group = group,
        setWebsiteToEdit: (state, website) => state.website = website,
        setThemeToEdit(state, theme) {
            localStorage.setItem('theme', JSON.stringify(theme));
            state.theme = theme
        },
        setUserToEdit: (state, user) => state.userEdit = user,
        setComponentToEdit(state, component) {
            localStorage.setItem('component', JSON.stringify(component));
            state.component = component
        },
        setFieldTypeToEdit: (state, fieldType) => state.fieldType = fieldType,
        setPageToEdit: (state, page) => state.page = page,
    },
    actions: {
        initialiseStore({state, dispatch, commit, getters}) {
            var user = localStorage.getItem('user');
            var theme = localStorage.getItem('theme');
            var component = localStorage.getItem('component');
            var cart = localStorage.getItem('cart');

            if (user) {
                state.user = JSON.parse(user);
            }

            if (theme) {
                state.theme = JSON.parse(theme);
            }

            if (component) {
                state.component = JSON.parse(component);
            }

            localStorage.removeItem('cart')

            if (cart) {
                state.cart.products = JSON.parse(cart)
                commit('cart/setTotal', getters['cart/getTotalQuantity'])
            } else {
                var auth = document.getElementById('auth_status')
                if (auth) {
                    dispatch('logout')
                    dispatch('cart/getCart')
                }
            }
        },
        logout() {
            localStorage.removeItem('user')
            localStorage.removeItem('theme')
            localStorage.removeItem('component')
            localStorage.removeItem('cart')
        },
        toast: (state, data) => {
            Toastr.options = state.toaster;
            Toastr[data.type](data.message, data.title);
        },
        dispatchError: ({dispatch}, error) => {
            let title = "Une erreur est survenue";
            let message = ""

            if (error.response && error.response.status) {
                switch (error.response.status) {
                    case 401:
                        message = (error.response.data.message) ? error.response.data.message : ''
                        break;

                    case 403:
                        message = (error.response.data.message) ? error.response.data.message : ''
                        break;

                    case 422:
                        title = (error.response.data.message) ? error.response.data.message : "Erreur de validation des données"
                        message = error.response.data.errors[Object.keys(error.response.data.errors)[0]]
                        break;
                }
            }

            dispatch('toast', {
                type: 'error',
                title: title,
                message: message
            });
        },
        prepareParams(context, config) {
            var field = config.sort

            if (config.sortDirection === 'desc') {
                field = '-' + field
            }

            var params = {
                page: config.page,
                include: config.include,
                sort: field
            }

            if (config.filters) {
                for (const [key, value] of Object.entries(config.filters)) {
                    params[`filter[${key}]`] = value
                }
            }

            return params
        }
    },
    modules: modules
})
